import { URLS } from '@/data';

export const addResizeParamToURL = (url: string, size: number): string => {
    return `${URLS.BETR_CDN_URL}/image/width=${size}/${url}`;
};
